export class EventQueue {
  constructor(processor) {
    this.queue = [];
    this.processing = false;
    this.processor = processor;
  }

  enqueue(event) {
    this.queue.push(event);
    this.process();
  }

  async process() {
    if (this.processing || this.queue.length === 0) return;
    this.processing = true;

    while (this.queue.length > 0) {
      const event = this.queue.shift();
      try {
        await this.processor(event);
      } catch (e) {
        console.error("EventQueue error processing event:", event, e);
      }
    }

    this.processing = false;
  }

  clear() {
    this.queue = [];
    this.processing = false;
  }
}
